import { combineReducers } from "redux";
import alertReducer from "./reducers/alert";
import betsReducer from "./reducers/bets";
import communicationsReducer from "./reducers/communications";
import depositReducer from "./reducers/deposit";
import groupBettingPoolsReducer from "./reducers/group-betting-pools";
import monthlyLeadersReducer from "./reducers/monthly-leaderboard";
import myGamesReducer from "./reducers/my-games";
import raceEntrantsReducer from "./reducers/race-entrants";
import racesReducer from "./reducers/races";
import sessionReducer from "./reducers/session";
import tagsReducer from "./reducers/tags";
import ticketsReducer from "./reducers/tickets";
import ticketScoresReducer from "./reducers/ticket-scores";
import timeReducer from "./reducers/time";
import tokenTypeReducer from "./reducers/token-types";
import tournamentChatsReducer from "./reducers/tournament-chats";
import tournamentsReducer from "./reducers/tournaments";
import transactionsReducer from "./reducers/transactions";
import usersReducer from "./reducers/users";
import withdrawReducer from "./reducers/withdraw";
import uiReducer from "./reducers/ui";

export default combineReducers({
  alert: alertReducer,
  bets: betsReducer,
  communications: communicationsReducer,
  deposit: depositReducer,
  groupBettingPools: groupBettingPoolsReducer,
  monthlyLeaders: monthlyLeadersReducer,
  myGames: myGamesReducer,
  races: racesReducer,
  raceEntrants: raceEntrantsReducer,
  session: sessionReducer,
  tags: tagsReducer,
  tickets: ticketsReducer,
  ticketScores: ticketScoresReducer,
  time: timeReducer,
  tokenTypes: tokenTypeReducer,
  tournaments: tournamentsReducer,
  transactions: transactionsReducer,
  users: usersReducer,
  tournamentChats: tournamentChatsReducer,
  withdraw: withdrawReducer,
  ui: uiReducer
});
